exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cursor-pointer[data-v-95b32838] {\n  cursor: pointer;\n}\n.isMain[data-v-95b32838] {\n  font-weight: bold;\n}\n.v-stepper__header[data-v-95b32838]{\n  height:50px;\n}\n.v-stepper__step[data-v-95b32838]{\n  padding:13px;\n}\n.v-stepper[data-v-95b32838]{\n  height:430px;\n}\n[data-v-95b32838] .v-list__tile{\n  height:32px;\n}\n[data-v-95b32838] .v-list__tile p{\n  margin-bottom:0;\n}\n.v-dialog__content[data-v-95b32838] {\n    z-index: 1030 !important;\n}\n", ""]);

// exports
